var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[_vm._v("正在退出...")])
}
var staticRenderFns = []

export { render, staticRenderFns }